import { cn } from '@utils/cn';
import ChevronsLeftSvg from '@vectors/chevron-left.svg';
import ChevronsRightSvg from '@vectors/chevron-right.svg';
import { Button } from '@common/interaction/Button';

import { usePrevNextButtons } from './CarouselArrowNavigation';

type CarouselNavigationButtonProps = Omit<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  'color'
> & {
  isAbsolute?: boolean;
  iconOnly?: boolean;
  isMobileVisible?: boolean;
};

const btnClasses = (
  isAbsolute: boolean,
  isMobileVisible: boolean,
  iconOnly: boolean,
  isNext: boolean,
) =>
  cn(
    'w-12 h-12 p-0',

    isAbsolute ? 'absolute top-1/2 -translate-y-1/2 z-10' : '',
    isNext ? 'right-4' : 'left-4',
    isMobileVisible ? '' : 'hidden',

    'items-center justify-center border-0 cursor-pointer transition-colors',
    'disabled:cursor-not-allowed disabled:bg-gray-300 disabled:invisible',
    iconOnly ? 'rounded-full' : 'rounded-none',
  );

export function CarouselPrevButton({
  children,
  iconOnly = false,
  isAbsolute = true,
  isMobileVisible = true,
  disabled,
  ...props
}: CarouselNavigationButtonProps) {
  return (
    <Button
      {...props}
      aria-label={props['aria-label'] ?? 'Vorige slide'}
      className={btnClasses(isAbsolute, isMobileVisible, iconOnly, false)}
      color="secondary"
      disabled={disabled}
      variant="contained"
    >
      <ChevronsLeftSvg className="w-6 h-6 stroke-accent" />
      {children}
    </Button>
  );
}

export function CarouselNextButton({
  children,
  iconOnly = false,
  isAbsolute = true,
  isMobileVisible = true,
  disabled,
  ...props
}: CarouselNavigationButtonProps) {
  return (
    <Button
      {...props}
      aria-label={props['aria-label'] ?? 'Volgende slide'}
      className={btnClasses(isAbsolute, isMobileVisible, iconOnly, true)}
      color="secondary"
      disabled={disabled}
      variant="contained"
    >
      <ChevronsRightSvg className="w-6 h-6 stroke-accent" />
      {children}
    </Button>
  );
}

export { usePrevNextButtons };
